import { castArray } from 'lodash';
import { ItemType } from 'shared/types/portfolios';

export const getSelectedItems = (ids: string[] | string, type: ItemType = ItemType.SCOPEONEID) => ({
  count: castArray(ids).length,
  itemIds: castArray(ids).reduce((itemIds, id) => ({ ...itemIds, [id]: id }), {}),
  items: {},
  type,
});
